import styled from 'styled-components'

export const Container = styled.div`
  text-align: center;
`

export const ImageWrapper = styled.div`
  margin-bottom: 30px;
  margin-left: -5%;
`

export const Image = styled.img`
  height: 20vh;
`
